<template>
        <div :class="['FullFrameBouton', {'show': state.level < 2 && !state.notFound }]"
        @mouseenter="setCursor(true)"  
        @mouseleave="setCursor(false)"
        @click="onClick"
        >
            <img v-show="!isFullscreen" class="FullFrameBouton-open" src="/img/fullscreen_open.svg" alt="fullscreen_open">
            <img v-show="isFullscreen" class="FullFrameBouton-close" src="/img/fullscreen_close.svg" alt="fullscreen_open">
        </div>
</template>

<script>
import Store from '@/stores/store.js'
export default {
    name: 'FullFrameBouton',
    data(){
        return {
            isFullscreen: false,
            screen: document.documentElement,
            state: Store.state
        }
    },
    methods: {
        setCursor(bool) {
            this.state.isHovering = bool
            this.state.cursorHover = bool
            this.state.cursorText = ''
        },
        onClick() {
            !this.isFullscreen ? this.openFullscreen() : this.closeFullscreen()
        },
        openFullscreen() {
            if (this.screen.requestFullscreen) {
                this.screen.requestFullscreen();
            } else if (this.screen.mozRequestFullScreen) { /* Firefox */
                this.screen.mozRequestFullScreen();
            } else if (this.screen.webkitRequestFullscreen) { /* Chrome, Safari and Opera */
                this.screen.webkitRequestFullscreen();
            } else if (this.screen.msRequestFullscreen) { /* IE/Edge */
                this.screen.msRequestFullscreen();
            }
            this.isFullscreen = true 
        },

        /* Close fullscreen */
        closeFullscreen() {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            } else if (document.mozCancelFullScreen) { /* Firefox */
                document.mozCancelFullScreen();
            } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                document.webkitExitFullscreen();
            } else if (document.msExitFullscreen) { /* IE/Edge */
                document.msExitFullscreen();
            }
            this.isFullscreen = false 
        }
    }
}
</script>


<style scoped lang="scss">
    .FullFrameBouton{
        position: fixed;
        bottom: 60px;
        right: 60px;
        height: 20px;
        width: 40px;
        z-index: zindex(back);
        color: white;
        opacity: 0;
        transition: 0.3s ease-out opacity;
        transition-delay: 0s;
        cursor: none;
        mix-blend-mode: difference;

        img {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            transform-origin: center;
            transition: 0.3s ease-in-out transform;
        }

        &:hover {
            img {
               &:first-child {
                    transform: scale(1.1);
               }

               &:last-child {
                   transform: scale(0.9);
               }
            }
        }
    }

    
    .show {
        transition-delay: 0.4s;
        opacity: 1;
    }
</style>
